;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/detail/:entryId\",\"regex\":\"^/detail/([^/]+)$\",\"paramNames\":[\"entryId\"],\"hasOptionalPrefix\":false},{\"path\":\"/in-app/detail/v1/:entryId\",\"regex\":\"^/in-app/detail/v1/([^/]+)$\",\"paramNames\":[\"entryId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/campaign/10th-anniversary\"},{\"path\":\"/errors/404\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import {
  getWebInstrumentations,
  initializeFaro,
  TransportItemType,
  type EventEvent,
  type TransportItem
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

const NOT_OURS = /^(?!https?:\/\/([a-z0-9-]+\.)*8percent\.kr([/?#]|$))/i

const COLLECTOR = /^https?:\/\/rum\.8percent\.kr/i

const IGNORE_URLS = [NOT_OURS, COLLECTOR]

function isObserved(value: string): boolean {
  return !NOT_OURS.test(value) && !COLLECTOR.test(value)
}

const EVENT_URL_KEYS = ['name', 'http.url', 'url']

// ignoreUrls 는 span 생성 시점에만 적용된다. 같은 요청이 만드는 성능·요청추적
// 이벤트는 그 경로를 지나지 않아 여기서 따로 걸러야 한다.
function dropForeignEvents(item: TransportItem): TransportItem | null {
  if (item.type !== TransportItemType.EVENT) return item

  const attributes = (item.payload as EventEvent).attributes ?? {}
  const target = EVENT_URL_KEYS.map(key => attributes[key]).find(value => typeof value === 'string')

  if (typeof target !== 'string') return item

  return isObserved(target) ? item : null
}

function backendMatcher(): RegExp[] {
  const base = process.env.NEXT_PUBLIC_CORE_API_URL
  if (!base) return []

  try {
    const origin = new URL(base).origin
    return [new RegExp('^' + origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))]
  } catch {
    return []
  }
}

// RUN_MODE 는 앱 공용 플래그라 값을 바꾸지 않는다. OpenTelemetry semconv 는
// well-known 값이 있으면 그것을 쓰도록 정하므로 방출 시점에만 옮긴다.
const OTEL_ENVIRONMENT: Record<string, string> = {
  production: 'production',
  develop: 'development',
  testing: 'test'
}

function otelEnvironment(): string {
  const mode = process.env.NEXT_PUBLIC_RUN_MODE
  return (mode && OTEL_ENVIRONMENT[mode]) || 'development'
}

const url = process.env.NEXT_PUBLIC_FARO_URL

const faro = url
  ? initializeFaro({
      url,
      apiKey: process.env.NEXT_PUBLIC_FARO_API_KEY || undefined,
      app: {
        name: 'events-front',
        environment: otelEnvironment()
      },
      ignoreUrls: IGNORE_URLS,
      beforeSend: dropForeignEvents,
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: backendMatcher()
          }
        })
      ]
    })
  : undefined

// Next 15.3 부터 클라이언트 진입점이 이 파일로 바뀌어 sentry.client.config.ts 가
// 자동 주입되지 않는다. 운영은 밀린 이슈 유입 범위를 팀과 정한 뒤 연다.
if (process.env.NEXT_PUBLIC_RUN_MODE === 'develop') {
  void import('./sentry.client.config').then(async () => {
    const Sentry = await import('@sentry/nextjs')

    Sentry.addEventProcessor(event => {
      const trace = faro?.api?.getTraceContext?.()
      const sessionId = faro?.api?.getSession?.()?.id

      if (trace || sessionId) {
        event.tags = {
          ...event.tags,
          ...(trace ? { otel_trace_id: trace.trace_id } : {}),
          ...(sessionId ? { faro_session_id: sessionId } : {})
        }
      }

      return event
    })
  })
}
